module.exports = __webpack_public_path__ + "img/icon-16-up.08dc9582.svg";